export default class ItemHistorico {
    constructor({ nomeTela, dados, atribuicoes, log }) {
        this.nomeTela = nomeTela;
        this.dados = dados;
        this.atribuicoes = atribuicoes;
        this.log = log;
    }
}
